import {
  Input,
  Output,
  OnInit,
  ViewChild,
  Component,
  HostListener,
  EventEmitter,
  SimpleChanges,
  ElementRef,
  AfterViewInit,
} from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';

import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { jqxCheckBoxComponent } from 'jqwidgets-ng/jqxcheckbox';
import { jqxNumberInputComponent } from 'jqwidgets-ng/jqxnumberinput';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';

import { SsoService } from 'src/app/services/sso/sso.service';

import { RolModel } from 'src/app/services/sso/models/rol.model';

import { PeriodoSelectComponent } from '../periodo-select/periodo-select.component';
import { LopdManager } from 'src/app/managers/lopd.manager';
import { OpcionesAplicacionesModel } from 'src/app/services/ciudadanos/models/lopdCiudadano.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  adapterRoles: any;
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.code === "Enter") {
      this.onFilter();
    }
  }

  static _this: any;

  // Elementos html
  @ViewChild('searchInput') searchInput: HTMLInputElement;
  @ViewChild('listApps') listApps: jqxDropDownListComponent;
  @ViewChild('listRoles') listRoles: jqxDropDownListComponent;
  @ViewChild('checkAlarms') checkAlarms: jqxCheckBoxComponent;
  @ViewChild('searchInforme') searchInforme: jqxInputComponent;
  @ViewChild('numeroTarjeta') numeroTarjeta: jqxInputComponent;
  @ViewChild('searchInputApi') searchInputApi: HTMLInputElement;
  @ViewChild('metrosInput') metrosInput: jqxNumberInputComponent;
  @ViewChild('periodoSelect') periodoSelect: PeriodoSelectComponent;
  @ViewChild('masXMetrosInput') masXMetrosInput: jqxNumberInputComponent;
  @ViewChild('checkMasXmetros') checkMasXmetros: jqxCheckBoxComponent;
  @ViewChild('cbVolumetricos') cbVolumetricos: jqxDropDownListComponent;
  @ViewChild('selectSubflotas') selectSubflotas: jqxDropDownListComponent;
  @ViewChild('listTabla') listTabla: jqxDropDownListComponent;
  @ViewChild('selectTipoEdificios') selectTipoEdificios: jqxDropDownListComponent;
  @ViewChild('numVisible') numVisible: jqxCheckBoxComponent;
  @ViewChild('scrollable') scrollable: ElementRef;

  // Periodo select
  @Input() height: number = 25;
  @Input() noDia: boolean = false;
  @Input() noMes: boolean = false;
  @Input() noAnno: boolean = false;
  @Input() noLibre: boolean = false;
  @Input() noSemana: boolean = false;
  @Input() noSemestre: boolean = false;
  @Input() noTrimestre: boolean = false;
  @Input() periodoAnterior: boolean = false;

  // Modificadores componentes
  @Input() filterApiError: boolean = false;

  // Mostrar/ocultar componentes
  @Input() filtro: boolean = false;
  @Input() periodo: boolean = false;
  @Input() buscador: boolean = false;
  @Input() exportar: boolean = false;
  @Input() subFlota: boolean = false;
  @Input() seeZonas: boolean = false;
  @Input() buscadorAPI: boolean = false;
  @Input() informesSso: boolean = false;
  @Input() checkMetros: boolean = false;
  @Input() resetFiltro: boolean = false;
  @Input() volumetricos: boolean = false;
  @Input() seeNumTarjeta: boolean = false;
  @Input() seeNumVisible: boolean = false;
  @Input() seeCheckAlarms: boolean = false;
  @Input() listadoEstados: boolean = false;
  @Input() lopdCiudadanos: boolean = false;
  @Input() tablalopdfilter: boolean = false;
  @Input() seeDropModoTarj: boolean = false;
  @Input() seeDropTipoTarj: boolean = false;
  @Input() seeFilterMetros: boolean = false;
  @Input() activeAppFilter: boolean = false;
  @Input() seeCheckTarjVirtual: boolean = false;
  @Input() tipoEdificios: boolean = false;

  // Lanza la accion cuando se interactua con un componente
  @Output() eventFilter: EventEmitter<Boolean> = new EventEmitter;
  @Output() eventExportar: EventEmitter<Boolean> = new EventEmitter;
  @Output() eventBuscador: EventEmitter<Boolean> = new EventEmitter;
  @Output() eventResetFilter: EventEmitter<Boolean> = new EventEmitter;

  @Output() informeSearchChange = new EventEmitter<string>();

  @Output() eventCheckRol: EventEmitter<any> = new EventEmitter;
  @Output() eventCheckApps: EventEmitter<any> = new EventEmitter;
  @Output() eventCheckEstados: EventEmitter<any> = new EventEmitter;
  @Output() eventCheckAlarms: EventEmitter<Boolean> = new EventEmitter;
  @Output() eventCheckMasMetros: EventEmitter<Boolean> = new EventEmitter;
  @Output() eventCheckTabla: EventEmitter<any> = new EventEmitter;
  @Output() eventCheckEdificios: EventEmitter<any> = new EventEmitter;

  @Output() eventChangeZona: EventEmitter<string> = new EventEmitter;
  @Output() eventChangeSubFlota: EventEmitter<any> = new EventEmitter;
  @Output() eventChangeMetros: EventEmitter<string> = new EventEmitter;
  @Output() eventChangedNumber: EventEmitter<Boolean> = new EventEmitter;
  @Output() eventChangeNumVisible: EventEmitter<Boolean> = new EventEmitter;
  @Output() eventChangeMasXMetros: EventEmitter<string> = new EventEmitter;
  @Output() eventChangeModoTarjeta: EventEmitter<string> = new EventEmitter;
  @Output() eventChangeTipoTarjeta: EventEmitter<string> = new EventEmitter;
  @Output() eventChangeNumeroTarjeta: EventEmitter<string> = new EventEmitter;

  private resizeObserver: ResizeObserver;

  public showLeftArrow = false;
  public showRightArrow = false;


  public environment = environment;
  public theme = this.environment.tema;
  roles: RolModel[];

  adapterApps: any;
  dataAdapterTabla: any;
  dataAdapterTipoEdificios: any;

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public constructor(
    private ssoService: SsoService,
    private lopdManager: LopdManager
  ) {
    HeaderComponent._this = this;
  }

  ngOnInit(): void {
    if (this.lopdCiudadanos) {
      //this.getrolesWithApp();
      this.loadListRoles();
    }
    if (this.activeAppFilter) {
      this.lopdManager.lopdApps.subscribe((apps: OpcionesAplicacionesModel[]) => {
        this.loadApps(apps);
      })
    }
  }

  ngAfterViewInit(): void {
    const el = this.scrollable.nativeElement;
    this.resizeObserver = new ResizeObserver(() => {
      this.updateArrows();
    });
    this.resizeObserver.observe(el);
  }

  onScroll() {
    this.updateArrows();
  }

  updateArrows() {
    const el = this.scrollable.nativeElement;
    this.showLeftArrow = el.scrollLeft > 0;
    this.showRightArrow = el.scrollLeft + el.clientWidth < el.scrollWidth;
  }

  scrollLeft() {
    this.scrollable.nativeElement.scrollBy({ left: -100, behavior: 'smooth' });
  }

  scrollRight() {
    this.scrollable.nativeElement.scrollBy({ left: 100, behavior: 'smooth' });
  }

  // Detecta cambios en variables de entrada
  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      this[propName] = changes[propName].currentValue;
    }
  }

  /* METODOS PARA TODAS LAS VENTANAS */
  onExportar() {
    this.eventExportar.emit(true);
  }

  onBuscar() {
    this.eventBuscador.emit(true);
  }

  onSearchInformes() {
    let searchInformes = this.searchInforme.val();
    this.informeSearchChange.emit(searchInformes);
  }

  onFilter() {
    this.eventFilter.emit(true);
  }

  onResetFilter() {
    this.eventResetFilter.emit(true);
  }
  /* FIN METODOS PARA TODAS LAS VENTANAS */

  /* METODOS PARA VENTANAS CONCRETAS */
  changeMasXmetros(event: any) {
    if (event.args.checked) {
      this.masXMetrosInput.disabled(true);
      this.masXMetrosInput.disabled(false);
    } else {
      this.masXMetrosInput.disabled(true);
    }

    this.eventCheckMasMetros.emit(true);
  }

  changeasXMetrosInput(event: any) {
    this.eventChangeMasXMetros.emit(event.args.value);
  }

  changeMetros(event: any) {
    this.eventChangeMetros.emit(event.args.value);
  }

  onChangeCheckAlarms(event: any) {
    if (event.args.checked) {
      this.eventCheckAlarms.emit(true);
    } else {
      this.eventCheckAlarms.emit(false);
    }
  }

  onChangeNumVisible(event: any) {
    this.eventChangeNumVisible.emit(event.args.checked);
  }

  onCheckEstados(event: any) {
    this.eventCheckEstados.emit(event);
  }

  onCheckRol(event: any) {
    let selectedItems = this.listRoles.getCheckedItems().map(x => ({
      value: x.value,
      label: x.label
    }));

    this.eventCheckRol.emit(selectedItems);
  }

  onCheckApps(event: any) {
    let selectedItems = this.listApps.getCheckedItems().map(x => ({
      value: x.value,
      label: x.label
    }));
    this.eventCheckApps.emit(selectedItems);
  }


  onCheckTablaLopd(event: any) {

    let selectedItems = this.listTabla.getCheckedItems().map(x => ({
      value: x.value,
      label: x.label
    }));
    this.eventCheckTabla.emit(selectedItems);

  }

  onChangeSubflotas(event: any) {
    this.eventChangeSubFlota.emit(event);
  }

  onChangeNumeroTarjeta(event) {
    this.eventChangeNumeroTarjeta.emit(event.args.value);
  }

  /* LISTADO MODO TARJETAS */
  @ViewChild('dropModoTarjeta') dropModoTarjeta: jqxDropDownListComponent;
  public sourceModoTarjetas: string[] =
    [
      AppComponent.translate('Todas'),
      AppComponent.translate('Virtuales'),
      AppComponent.translate('Fisicas')
    ];

  changeModoTarjeta(event: any) {
    this.eventChangeModoTarjeta.emit(event.args.item.value);
  }

  onLoadModoTarjeta() {
    setTimeout(() => {
      this.selectDefaultModoTarjeta();
    }, 50);
  }

  selectDefaultModoTarjeta() {
    if (this.dropModoTarjeta) {
      let items = this.dropModoTarjeta.getItems();
      if (items) {
        items.forEach((item, i) => {
          if (item['originalItem'] == AppComponent.translate('Todas')) {
            this.dropModoTarjeta.selectItem(item['originalItem']);
          }
        })
      }
    }
  }

  checkselectTipoEdificios(event: any) {
    let selectedItems = this.selectTipoEdificios.getCheckedItems().map(x => ({
      value: x.value,
      label: x.label
    }));
    this.eventCheckEdificios.emit(selectedItems);
  }

  /* LISTADO TIPO TARJETAS */
  @ViewChild('dropTipoTarjeta') dropTipoTarjeta: jqxDropDownListComponent;
  public sourceTipoTarjetas: string[] =
    [
      AppComponent.translate('Todas'),
      AppComponent.translate('Blanca'),
      AppComponent.translate('Master'),
      AppComponent.translate('Negra')
    ];

  changeTipoTarjeta(event: any) {
    this.eventChangeTipoTarjeta.emit(event.args.item.value);
  }

  onLoadTipoTarjeta() {
    setTimeout(() => {
      this.selectDefaultTipoTarjeta();
    }, 50);
  }

  selectDefaultTipoTarjeta() {
    if (this.dropTipoTarjeta) {
      let items = this.dropTipoTarjeta.getItems();
      if (items) {
        items.forEach((item, i) => {
          if (item['originalItem'] == AppComponent.translate('Todas')) {
            this.dropTipoTarjeta.selectItem(item['originalItem']);
          }
        })
      }
    }
  }

  /* LISTADO ZONAS */
  @ViewChild('dropZonas') dropZonas: jqxDropDownListComponent;
  @Input() sourceZonas: any;

  changeZona(event: any) {
    this.eventChangeZona.emit(event.args.item.value)
  }

  rolesWithApp: RolModel[] = [];
  dataAdapteRrolesWithApp: any;

  async getrolesWithApp(apps: []) {
    try {
      // Obtener todas las aplicaciones del proyecto
      let allRoles = await Promise.all(
        apps.map(async (element: any) => {
          let roles = await this.ssoService.getRolesAppByEmpresa(element.value);
          return roles
        }));

      let flattenedRoles = allRoles.reduce((acc, val) => acc.concat(val), []);
      this.rolesWithApp = flattenedRoles.reduce((acc, rol) => {
        if (!acc.some((existingRole) => existingRole.Id === rol.Id)) {
          acc.push(rol);
        }
        return acc;
      }, this.rolesWithApp);

    } catch (error) {
      console.error(error);
    }
    if (this.rolesWithApp) {
      let dataSource = {
        datatype: 'json',
        datafields: [
          { name: 'Aplicaciones', type: 'object', map: 'Aplicaciones' },
          { name: 'Id', type: 'number', map: 'Id' },
          { name: 'Nombre', type: 'string', map: 'Nombre' },
          { name: 'Descripcion', type: 'string', map: 'Descripcion' },
        ],
        localdata: this.rolesWithApp,
      };
      this.dataAdapteRrolesWithApp = new jqx.dataAdapter(dataSource);

      dataSource.localdata.sort((a, b) => (a.Nombre < b.Nombre ? -1 : 1));
      this.dataAdapteRrolesWithApp = new jqx.dataAdapter(dataSource,
        {
          beforeLoadComplete: (records: any[]): void => {
            records.sort((a, b) => (a.Nombre < b.Nombre ? -1 : 1));
          },
        }
      );
    }
  }

  async loadListRoles() {

    let roles = this.getRoles();

    let dataSource = {
      datatype: 'json',
      datafields: [
        { name: 'Id', type: 'number', map: 'Id' },
        { name: 'Nombre', type: 'string', map: 'Nombre' },
        { name: 'Descripcion', type: 'string', map: 'Descripcion' },
      ],
      localdata: roles,
    };

    (await dataSource.localdata).sort((a, b) => (a.Nombre < b.Nombre ? -1 : 1));
    this.dataAdapteRrolesWithApp = new jqx.dataAdapter(dataSource,
      {
        beforeLoadComplete: (records: any[]): void => {
          records.sort((a, b) => (a.Nombre < b.Nombre ? -1 : 1));
        },
      }
    );
  }

  async getRoles() {
    return await this.ssoService.getRoles();
  }

  public async loadApps(apps: OpcionesAplicacionesModel[]): Promise<void> {
    const appsMap = apps.map((app) => ({
      id: app.idAplicacion,
      nombre: app.nombreAplicacion
    }))

    const dataSource = {
      datatype: 'json',
      datafields: [
        { name: 'Id', type: 'string', map: 'id' },
        { name: 'Nombre', type: 'string', map: 'nombre' },
      ],
      localdata: appsMap,
    };

    dataSource.localdata.sort((a, b) => (a.nombre < b.nombre ? -1 : 1));
    this.adapterApps = new jqx.dataAdapter(dataSource,
      {
        beforeLoadComplete: (records: any[]): void => {
          records.sort((a, b) => (a.Nombre < b.Nombre ? -1 : 1));
        },
      }
    );
  }

  /* LISTADO ESTADOS */
  @ViewChild('listEstados') listEstados: jqxDropDownListComponent;
  @Input() adapterEstados: any;

  //una vez cargado del dropdown se hace check en los estados por defecto
  onLoadList() {
    setTimeout(() => {
      this.selectItems();
    }, 50);
  }

  //selecciona estados por defecto
  selectItems() {
    if (this.listEstados) {
      let items = this.listEstados.getItems();
      if (items) {
        items.forEach((item, i) => {
          if (item['originalItem'].Nombre == 'En proceso' || item['originalItem'].Nombre == 'Abierta') {
            this.listEstados.checkIndex(i)
          }
        })
      }
    }
  }

  get dropDownHeight(): number {
    const items = this.selectSubflotas?.getItems();
    return items ? 33 * items.length : 33;
  }

  get dropDownHeightropZonas(): number {
    return this.sourceZonas?.length < 10 ? (30 * this.sourceZonas?.length) : 300;
  }


  selectionRolRenderer = (): string => {
    if (this.listRoles) {
      let selectedItems = this.listRoles.getCheckedItems();
      if (selectedItems !== undefined && selectedItems.length > 0) {
        let itemValue = selectedItems.map(x => x.label).join(', ');
        return `<div style="position: relative; margin-left: 3px; margin-top: 5px;">${itemValue}</div>`;
      } else {
        return `<div style="position: relative; margin-left: 5px; margin-top: 5px;">${AppComponent.translate("Filtro_por_rol ")}</div>`;
      }
    }
  }

  selectionAppRenderer = (): string => {
    if (this.listApps) {
      let selectedItems = this.listApps.getCheckedItems();
      if (selectedItems !== undefined && selectedItems.length > 0) {
        let itemValue = selectedItems.map(x => x.label).join(', ');
        return `<div style="position: relative; margin-left: 3px; margin-top: 5px;">${itemValue}</div>`;
      } else {
        return `<div style="position: relative; margin-left: 5px; margin-top: 5px;">${AppComponent.translate("Filtro_por_aplicacion")}</div>`;
      }
    }
  }

  selectionTablaRenderer = (): string => {
    if (this.listTabla) {
      let selectedItems = this.listTabla.getCheckedItems();
      if (selectedItems !== undefined && selectedItems.length > 0) {
        let itemValue = selectedItems.map(x => x.label).join(', ');
        return `<div style="position: relative; margin-left: 3px; margin-top: 5px;">${itemValue}</div>`;
      } else {
        return `<div style="position: relative; margin-left: 5px; margin-top: 5px;">${AppComponent.translate("Filtro_por_tabla")}</div>`;
      }
    }
  }

  selectionTipoEdificioRenderer = (): string => {
    if (this.selectTipoEdificios) {
      let selectedItems = this.selectTipoEdificios.getCheckedItems();
      if (selectedItems !== undefined && selectedItems.length > 0) {
        let itemValue = selectedItems.map(x => x.label).join(', ');
        return `<div style="position: relative; margin-left: 3px; margin-top: 5px;">${itemValue}</div>`;
      } else {
        return `<div style="position: relative; margin-left: 5px; margin-top: 5px;">${AppComponent.translate("Filtro_por_edificio")}</div>`;
      }
    }
  }

  selectionZonesRenderer = (): string => {
    if (!this.dropZonas) {
      return `<div style="position: relative; margin-left: 5px; margin-top: 5px;">${AppComponent.translate("Cargando")}</div>`;
    }

    let selectedItems = this.dropZonas.getSelectedItem();
    if (selectedItems !== undefined && selectedItems) {
      let itemValue = selectedItems.label;
      return `<div style="position: relative; margin-left: 3px; margin-top: 5px;">${itemValue}</div>`;
    } else {
      return `<div style="position: relative; margin-left: 5px; margin-top: 5px;">${AppComponent.translate("Selecciona_zona")}</div>`;
    }
  };
  /* FIN METODOS PARA VENTANAS CONCRETAS */
}
